import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as Editor from '@ck/build/ckeditor';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';

@Component({
	selector: 'app-edit-markdown',
	template: `
		<ckeditor [editor]="Editor" [config]="ckeConfig" [data]="value" (change)='onChange($event)'></ckeditor>
	`,
	styles: [`
	`],
})
export class EditMarkdownComponent implements OnInit{
	@Input() model;
	@Output() modelChange: EventEmitter<any> = new EventEmitter();

	public Editor = Editor;
	ckeConfig = {
		toolbar: {
			items: [
				'heading',
				// 'fontSize',
				'|',
				'bold',
				'italic',
				'link',
				'bulletedList',
				'numberedList',
				'removeFormat',
				'strikethrough',
				'|',
				// 'outdent',
				// 'indent',
				'|',
				'imageUpload',
				'resizeImage',
				// 'imageInsert',
				// 'blockQuote',
				'insertTable',
				'undo',
				'redo',
				'code',
				// 'codeBlock',
				'|',
				'horizontalLine',
				'fontBackgroundColor',
				'fontColor',
				'todoList',
				'sourceEditing',
				// 'findAndReplace'
			]
		},
		language: 'en',
		image: {
			toolbar: [
				'imageTextAlternative',
				'imageStyle:inline',
				'imageStyle:block',
				'imageStyle:side',
				'linkImage'
			],
			styles: [
				'full',
				'side',
				'alignLeft', 'alignCenter', 'alignRight'
			],
			resizeOptions: [
				{
					name: 'imageResize:original',
					label: 'Original',
					value: null
				},
				{
					name: 'imageResize:50',
					label: '50%',
					value: '50'
				},
				{
					name: 'imageResize:75',
					label: '75%',
					value: '75'
				}
			],
		},
		table: {
			contentToolbar: [
				'tableColumn',
				'tableRow',
				'mergeTableCells'
			]
		}
	};
	value: string;

	constructor() {}

	ngOnInit(): void {
		this.value = this.model + "";
	}

	public onChange( { editor }: ChangeEvent ) {
		const data = editor.getData();
		this.modelChange.emit(data)
	}
}
